import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './settings-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class SettingsIconComponent {}
